// TODO backoffice banner 에 Partner 추가하고 제거 필요

import { AptosIcon, BnbIcon, KaiaIcon, ScallopIcon, TetherIcon, TonIcon, WlfiIcon } from '@web/assets/svgs';

export const partners = [
  {
    name: 'Tether',
    icon: <TetherIcon />,
    url: 'https://tether.to/en/',
  },
  {
    name: 'Wlfi',
    icon: <WlfiIcon />,
    url: 'https://worldlibertyfinancial.com/',
  },
  {
    name: 'Ton',
    icon: <TonIcon />,
    url: 'https://ton.foundation/en',
  },
  {
    name: 'BNB',
    icon: <BnbIcon />,
    url: 'https://www.bnbchain.org/en',
  },
  {
    name: 'Aptos',
    icon: <AptosIcon />,
    url: 'https://aptosfoundation.org/',
  },
  {
    name: 'Kaia',
    icon: <KaiaIcon />,
    url: 'https://www.kaia.io/',
  },
  {
    name: 'Scallop',
    icon: <ScallopIcon />,
    url: 'https://www.scallop.io/',
  },
];
